import React, { useState } from "react";

const TIPS = [
  { label: "Loose-leaf tea", text: "perfect as it is; the leaves are your reading." },
  { label: "Tea bag", text: "snip it open and stir a little of the leaves in before your last sip." },
  { label: "Turkish / Greek coffee", text: "the fine grounds settle into a soft mud; ideal." },
  { label: "Press or moka-pot coffee", text: "swirl the last of it; the sediment is what we read." },
  { label: "Filtered / drip / pod coffee", text: "leaves little behind; try a press, or a pinch of fine grounds stirred in." },
];

export default function RitualNote() {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-testid="ritual-note"
      style={{
        maxWidth: 360,
        margin: "26px auto 0",
        border: "1px solid var(--hairline, rgba(243,233,214,0.12))",
        borderRadius: 16,
        background: "rgba(243,233,214,0.03)",
        overflow: "hidden",
      }}
    >
      <button
        type="button"
        data-testid="ritual-note-toggle"
        onClick={() => setOpen((o) => !o)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: "14px 18px",
          color: "var(--gold)",
          fontFamily: "'IM Fell DW Pica', serif",
          fontStyle: "italic",
          fontSize: 17,
        }}
      >
        <span>How it&rsquo;s traditionally done ✦</span>
        <span
          style={{
            transition: "transform 0.3s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            fontSize: 12,
            opacity: 0.8,
          }}
        >
          ▾
        </span>
      </button>
      {open && (
        <div
          data-testid="ritual-note-body"
          style={{
            padding: "14px 18px 18px",
            borderTop: "1px solid var(--hairline, rgba(243,233,214,0.10))",
            animation: "fadeIn 0.4s ease",
          }}
        >
          <p
            className="italic-quote"
            style={{
              fontFamily: "'IM Fell DW Pica', serif",
              fontStyle: "italic",
              fontSize: 18,
              lineHeight: 1.55,
              color: "var(--cream-soft)",
              margin: 0,
            }}
          >
            Hold your question in mind as you drink. When only a sip remains, swirl the cup three
            times, then turn it upside down onto the saucer and let it drain. The grounds left behind
            are what we read.
          </p>
          <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 9 }}>
            {TIPS.map((t) => (
              <p key={t.label} style={{ margin: 0, fontFamily: "'IM Fell English', Georgia, serif", fontSize: 14, lineHeight: 1.5 }}>
                <span style={{ color: "var(--cream)" }}>{t.label}</span>
                <span style={{ color: "var(--dim)" }}> — {t.text}</span>
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
